export var MessageExecutors;
(function (MessageExecutors) {
    MessageExecutors["startFollowerInstance"] = "startFollowerInstance";
    MessageExecutors["isAuthenticated"] = "isAuthenticated";
    MessageExecutors["ethereumAddress"] = "ethereumAddress";
    MessageExecutors["currentNetwork"] = "currentNetwork";
    MessageExecutors["enabledNetworks"] = "enabledNetworks";
    MessageExecutors["currentCurrency"] = "currentCurrency";
    MessageExecutors["setCurrency"] = "setCurrency";
    MessageExecutors["enabledCurrencies"] = "enabledCurrencies";
    MessageExecutors["cancelTransaction"] = "cancelTransaction";
    MessageExecutors["updateGasForTransaction"] = "updateGasForTransaction";
    MessageExecutors["userActive"] = "userActive";
    MessageExecutors["routeTo"] = "routeTo";
    MessageExecutors["logout"] = "logout";
    MessageExecutors["versionInfo"] = "versionInfo";
    MessageExecutors["isKycVerified"] = "isKycVerified";
    MessageExecutors["kycModalOpen"] = "kycModalOpen";
    MessageExecutors["authenticationModalOpen"] = "authenticationModalOpen";
    MessageExecutors["playerProtection"] = "playerProtection";
    MessageExecutors["signInterpretedBytes"] = "signInterpretedBytes";
    MessageExecutors["appJwtToken"] = "appJwtToken";
    MessageExecutors["getMarketingOptInStatus"] = "getMarketingOptInStatus";
    MessageExecutors["updateMarketingOptInStatus"] = "updateMarketingOptInStatus";
    MessageExecutors["gasRecommendations"] = "gasRecommendations";
    MessageExecutors["userAccountId"] = "userAccountId";
    MessageExecutors["enabledERC20Tokens"] = "enabledERC20Tokens";
    MessageExecutors["enabledERC20Token"] = "enabledERC20Token";
    MessageExecutors["erc20TokenIcon"] = "erc20TokenIcon";
    MessageExecutors["erc20TokenFiatPrice"] = "erc20TokenFiatPrice";
    MessageExecutors["erc20TokenBalance"] = "erc20TokenBalance";
    MessageExecutors["erc20TokenBalances"] = "erc20TokenBalances";
    MessageExecutors["ethBalance"] = "ethBalance";
    MessageExecutors["ethFiatPrice"] = "ethFiatPrice";
    MessageExecutors["pendingTransactions"] = "pendingTransactions";
    // a way to reject the approval modal if you want to close it
    // from the dApp point of view
    MessageExecutors["rejectApprovalModal"] = "rejectApprovalModal";
    MessageExecutors["personal_sign"] = "personal_sign";
    // internal message events for wallet sdk only
    MessageExecutors["getTranslationText"] = "getTranslationText";
    MessageExecutors["authenticationPopUpClosed"] = "authenticationPopUpClosed";
    MessageExecutors["eth_accounts"] = "eth_accounts";
    MessageExecutors["eth_chainId"] = "eth_chainId";
    MessageExecutors["eth_sendTransaction"] = "eth_sendTransaction";
    MessageExecutors["eth_getTransactionReceipt"] = "eth_getTransactionReceipt";
    MessageExecutors["eth_sign"] = "eth_sign";
    MessageExecutors["eth_signTransaction"] = "eth_signTransaction";
    MessageExecutors["eth_sendRawTransaction"] = "eth_sendRawTransaction";
    MessageExecutors["eth_call"] = "eth_call";
    MessageExecutors["eth_getBalance"] = "eth_getBalance";
    MessageExecutors["eth_blockNumber"] = "eth_blockNumber";
    MessageExecutors["eth_gasPrice"] = "eth_gasPrice";
    MessageExecutors["eth_getTransactionCount"] = "eth_getTransactionCount";
    MessageExecutors["eth_getCode"] = "eth_getCode";
    MessageExecutors["eth_syncing"] = "eth_syncing";
    MessageExecutors["eth_protocolVersion"] = "eth_protocolVersion";
    MessageExecutors["eth_estimateGas"] = "eth_estimateGas";
    MessageExecutors["eth_getBlockByHash"] = "eth_getBlockByHash";
    MessageExecutors["eth_getBlockByNumber"] = "eth_getBlockByNumber";
    MessageExecutors["eth_getTransactionByHash"] = "eth_getTransactionByHash";
    MessageExecutors["eth_getBlockTransactionCountByHash"] = "eth_getBlockTransactionCountByHash";
    MessageExecutors["eth_getStorageAt"] = "eth_getStorageAt";
    MessageExecutors["eth_getBlockTransactionCountByNumber"] = "eth_getBlockTransactionCountByNumber";
    MessageExecutors["eth_getTransactionByBlockHashAndIndex"] = "eth_getTransactionByBlockHashAndIndex";
    MessageExecutors["eth_getTransactionByBlockNumberAndIndex"] = "eth_getTransactionByBlockNumberAndIndex";
    MessageExecutors["eth_getUncleByBlockHashAndIndex"] = "eth_getUncleByBlockHashAndIndex";
    MessageExecutors["eth_getUncleByBlockNumberAndIndex"] = "eth_getUncleByBlockNumberAndIndex";
    MessageExecutors["eth_getUncleCountByBlockHash"] = "eth_getUncleCountByBlockHash";
    MessageExecutors["eth_getUncleCountByBlockNumber"] = "eth_getUncleCountByBlockNumber";
    MessageExecutors["eth_getLogs"] = "eth_getLogs";
    // not supported
    // eth_newFilter = 'eth_newFilter',
    // eth_newBlockFilter = 'eth_newBlockFilter',
    // eth_getFilterChanges = 'eth_getFilterChanges',
    // eth_getFilterLogs = 'eth_getFilterLogs',
    // eth_uninstallFilter = 'eth_uninstallFilter',
    // eth_newPendingTransactionFilter = 'eth_newPendingTransactionFilter',
})(MessageExecutors || (MessageExecutors = {}));
//# sourceMappingURL=message-executors.js.map